export const GLOBAL_API_ERROR_MODAL_EVENT = "pmtoolbox:api-error-modal";

let globalApiErrorModalOpen = false;

/** Called when the global API error modal opens/closes (suppresses duplicate error toasts). */
export function setGlobalApiErrorModalOpen(open) {
  globalApiErrorModalOpen = Boolean(open);
}

export function isGlobalApiErrorModalOpen() {
  return globalApiErrorModalOpen;
}

/**
 * Opens the shared API error modal for page-level mutation failures.
 * Payload shape: { title?: string, message: string }
 */
export function emitGlobalApiErrorModal(payload) {
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") return;
  const detail =
    payload && typeof payload === "object"
      ? payload
      : { message: typeof payload === "string" ? payload : "Something went wrong" };
  window.dispatchEvent(new window.CustomEvent(GLOBAL_API_ERROR_MODAL_EVENT, { detail }));
}
